import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  styled,
} from '@mui/material';

export type Props = Omit<MuiButtonProps, 'startIcon' | 'endIcon'>;

const IconButton = styled(MuiButton, {
  name: 'StyledIconButton',
})(({ theme }) => ({
  '&': {
    boxShadow: 'none',
    transition: '300ms ease-in-out',
    borderRadius: '10em',
    minWidth: '0px',
    padding: 0,

    '&:hover': {
      boxShadow: 'none',
    },
  },

  '&.MuiButton-containedPrimary': {
    backgroundColor: theme.colors['primary_500'],
    color: theme.colors.white,

    '&:hover': {
      backgroundColor: theme.colors['primary_300'],
    },
  },

  '&.MuiButton-containedSecondary': {
    color: theme.colors.white,
    backgroundColor: theme.colors.black,

    '&:hover': {
      backgroundColor: theme.colors['neutral_800'],
    },
  },

  '&.MuiButton-outlined': {
    border: `1px solid ${theme.colors['neutral_200']}`,
    color: theme.colors.black,

    '&:hover': {
      backgroundColor: theme.colors['neutral_100'],
    },
  },

  '&.MuiButton-sizeSmall': {
    fontSize: '18px',
    width: '40px',
    height: '40px',
  },

  '&.MuiButton-sizeMedium': {
    fontSize: '22px',
    width: '48px',
    height: '48px',
  },

  '&.MuiButton-sizeLarge': {
    fontSize: '26px',
    width: '56px',
    height: '56px',
  },

  '&.Mui-disabled': {
    backgroundColor: theme.colors['neutral_100'],
    color: theme.colors['neutral_500'],
  },
}));

export default IconButton;
